<template>



  <v-parallax src="@/assets/img/backgrounds/dark-ice-medium.jpeg" height="1000">
    <v-row class="mt-12 fill align-center justify-center">
      <v-col cols="12" class="text-center title-margin">
        <v-img src="@/assets/img/logos/superliga.png" alt="Domácí tým" height="250"></v-img>

       
      </v-col>
    </v-row>
  </v-parallax>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { IEvent } from '@/types';
import axios from 'axios';
import { useEventTileResolver } from '@/composables/useEventTileResolver'

// Ref pro uložení seznamu událostí
const events = ref<IEvent[]>([]);

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

// Funkce pro načtení událostí z API
const fetchEvents = async () => {

};

const { getEventTileComponent } = useEventTileResolver()

// Načítání událostí při mountování komponenty
onMounted(() => {
  fetchEvents();
});
</script>

<style scoped>
.mhred {
  color: #d32f2f;
  /* Můžete změnit barvu dle potřeby */
}

.border-bottom {
  border-bottom: 10px solid red;
}

.dummy-tile {
  text-align: center;
  color: #9e9e9e;
}
</style>
